import { createNavigationContainerRef } from '@react-navigation/native';

import { RouteNavigationParams } from 'router/types.ts';

export const navigationRef =
    createNavigationContainerRef<RouteNavigationParams>();
